module.exports = __webpack_public_path__ + "img/research.b20b95b4.png";